import React from "react";
import * as styles from "./component.module.less";
import { Button } from "../../Button";
import CookieBannerItem from "../CookieBannerItem/CookieBannerItem";
import CookieBannerHeader from "../CookieBannerHeader/CookieBannerHeader";
import { useMemo } from "react";

export default function CookieBannerGroup({
    currentPage,
    setCurrentPage,
    settingsTitle,
    pages
}) {
    const isSettingsPage = "settings" === currentPage;

    const currentPageContent = useMemo(() =>
        pages.find((page) => page.name === currentPage, [])
    );

    return (
        <div className={styles.cookieGroupWrapper}>
            <CookieBannerHeader
                {...{ currentPage, setCurrentPage, settingsTitle }}
                cookieGroupId={currentPageContent?.key}
                groupFunctions={currentPageContent?.functions}
                title={currentPageContent?.name}
            />

            {isSettingsPage ? (
                <div className={styles.cookieGroupContent}>
                    {pages.map((page) => (
                        <Button
                            key={page.key}
                            type={"secondary"}
                            icon="chevronRight"
                            iconPosition="right"
                            onClick={() => setCurrentPage(page.name)}
                        >
                            {page.name}
                        </Button>
                    ))}
                </div>
            ) : (
                <CookieBannerItem
                    description={currentPageContent?.description}
                    cookies={currentPageContent?.cookie}
                />
            )}
        </div>
    );
}
